import * as React from 'react'

import { RotateCcw, X } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

export function ResetButton({
  onClick,
  size = 'sm',
}: {
  onClick: () => void
  size?: 'sm' | 'default' | 'lg'
}) {
  return (
    <Button
      variant="destructive"
      size={size}
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
    >
      <RotateCcw />
      {Localization.translator.reset}
    </Button>
  )
}

export function SelectionChip({
  label,
  onRemove,
}: {
  label: string
  onRemove: (e: React.MouseEvent) => void
}) {
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={onRemove}
      title={label}
      className="tw:inline-flex tw:max-w-full tw:min-w-0 tw:items-center tw:gap-1 tw:rounded-md tw:bg-muted tw:px-2 tw:py-0.5 tw:text-app-dense tw:cursor-pointer tw:hover:bg-accent tw:hover:text-accent-foreground"
    >
      <span className="tw:min-w-0 tw:flex-1 tw:truncate">{label}</span>
      <X className="tw:size-3 tw:shrink-0" />
    </span>
  )
}
